import { getShopId, TrackingClientState } from '../helpers/clientState'
import { stringifyEventData } from '../helpers/stringifyEventData'
import { TrackingCustomerData } from '../../../types'
import { getCustomerIdAndCustomerIdHash } from './trackCustomerData'

interface LandingPageEvent {
  event: 'landingpage'
  action: string
  label: null
  value: null
  landingPage: string
  sdkVersion: string
}

interface ShopInit {
  event: 'shop_init'
  action: string
  landing_page: string
  sdk_version: string
  shop_id: string
  shop_version: string
  shop_gender: string
  locale: string
  shop_currency: string
  // document.location.search
  parameter: string | null
  // document.referrer
  referrer: string | null
  login?: boolean
  login_method?: 'none' | 'email' | 'facebook' | 'apple'
  customer_id?: number | null
  customer_type?: 'guest' | 'existing' | 'new'
}

const SDK_VERSION = '14.68.0'

export const trackLandingPage = (
  currentState: TrackingClientState,
  customer?: TrackingCustomerData,
) => {
  const eventGA3: LandingPageEvent = {
    event: 'landingpage',
    action: currentState.landingPage,
    label: null,
    value: null,
    landingPage: currentState.landingPage,
    sdkVersion: SDK_VERSION,
  }

  const eventGA4: ShopInit = {
    event: 'shop_init',
    shop_id: getShopId(currentState.shop),
    shop_version: stringifyEventData([
      currentState.shop.appVersion,
      currentState.shop.gitHash,
    ]),
    landing_page: currentState.landingPage,
    action: currentState.landingPage,
    sdk_version: SDK_VERSION,

    shop_currency: currentState.currency,
    shop_gender: currentState.shopGender || '',
    locale: currentState.locale || '',
    parameter: currentState.parameter || '',
    referrer: currentState.referrer || '',
    login: customer ? customer.type !== 'guest' : undefined,
    login_method: customer ? 'none' : undefined,
    customer_id: customer
      ? getCustomerIdAndCustomerIdHash(customer).customerId
      : undefined,
    customer_type: customer ? customer.type : undefined,
  }

  const event = {
    GA3: eventGA3,
    GA4: eventGA4,
  }
  return event
}
